import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataTaxRate } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_TAX_RATE = defineMasterdataEntity<MasterdataTaxRate>({
  name: 'tax-rate',
  responseKey: 'taxRates',
  displayWith: (t) => {
    const name = keyName(t.key, t.name);
    return t.rate != null ? `${name} (${t.rate}%)` : name;
  },
  icon: 'fa-regular fa-percent',
  title: 'Steuersatzsuche',
  label: 'Steuersatz',
  placeholder: 'Steuersatz suchen...',
  columns: [
    {
      label: 'Steuersatz',
      type: 'entity',
      icon: 'fa-regular fa-percent',
      value: (e) => keyName(e.key, e.name),
    },
    { label: 'Schlüssel', type: 'text', value: (e) => e.key },
    { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
    { label: 'Satz', type: 'text', value: (e) => e.rate, align: 'end' },
  ],
});
